import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { truncateFooter } from '@shared/utils/object-mapper.util';

@Component({
  selector: 'app-widget-footer',
  templateUrl: './widget-footer.component.html'
})
export class WidgetFooterComponent {

  @ViewChild('toolTipTitle', { static: true }) toolTipTitle: TemplateRef<any>;
  tooltipContent: string;

  _widgetFooter: Widget.FooterModel;
  get widgetFooter(): Widget.FooterModel {
    return this._widgetFooter;
  }

  @Input('widgetFooter')
  set widgetFooter(widgetFooter: Widget.FooterModel) {
    this._widgetFooter = widgetFooter;

    if (widgetFooter.left) {
      widgetFooter.left = truncateFooter(widgetFooter.left);
    }
  };
}
